import { Component, OnInit } from '@angular/core';
import { PropertiesService } from '../../services/properties.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-properties',
    templateUrl: './properties.component.html',
    styleUrls: ['./properties.component.css'],
    standalone: false
})
export class PropertiesComponent implements OnInit {

  loading: boolean;
  error: boolean;
  msjError: string;
  propiedades: any = [];
  image: any;

  // 👇 Nuevo: control de vista
  viewMode: 'list' | 'map' = 'list';

  constructor(
      private propertiesService: PropertiesService,
      activateRoute: ActivatedRoute,
      private router: Router) {

    this.error = false;
    this.loading = true;

    if (localStorage.getItem('viewMode')) {
      this.viewMode = localStorage.getItem('viewMode') as 'list' | 'map';
    }

    if(localStorage.getItem("filter") === null){
      let fil: any = {};
      fil.tipoOpe = activateRoute.snapshot.url[0].path;
      this.getPropiedades(fil);
    }
    else{
      let filter = JSON.parse(localStorage.getItem('filter'));
      filter.tipoOpe = activateRoute.snapshot.url[0].path.toUpperCase();
      localStorage.setItem('filter', JSON.stringify(filter));
      this.getPropiedades(filter);
    }
     activateRoute.queryParams.subscribe(params => {
    if (params['view']) {
      this.viewMode = params['view'];
      localStorage.setItem('viewMode', this.viewMode);
    }
  });
  }

  ngOnInit(): void {}

  getPropiedades(filter){
    this.propertiesService.getPropiedades(
      filter.tipoOpe,
      filter.tipoPr,
      filter.localidad,
      filter.barrio,
      filter.dormitorio,
      filter.cochera,
      filter.patio,
      filter.apCredito,
      0,
      50
    ).subscribe({
      next: (data: any[]) => {
        this.propiedades = data;
        this.loading = false;
      },
      error: (errorService) => {
        this.error = true;
        this.loading = false;
        this.msjError = errorService.error.title;
      }
    });
  }

  // 👇 Nuevo: setear modo de vista
  setView(mode: 'list' | 'map') {
    this.viewMode = mode;
    localStorage.setItem('viewMode', mode); 
  }

}
